module.exports = __webpack_public_path__ + "static/media/2-Rakha.3d5744ab.webp";